import { StatusBadge } from "@/components/wheel/StatusBadge";

function scoreTone(status) {
  if (status === "Hotter") return { color: "#10B981", bg: "linear-gradient(135deg, rgba(16,185,129,0.18), rgba(16,185,129,0.02))" };
  if (status === "Cooler") return { color: "#F87171", bg: "linear-gradient(135deg, rgba(248,113,113,0.16), rgba(248,113,113,0.02))" };
  return { color: "var(--hoip-text-secondary)", bg: "transparent" };
}

export function SentimentHeatmapTiles({ comparison }) {
  const c = comparison || {};
  const tone = scoreTone(c.status);
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2" data-testid="sentiment-heatmap-tiles">
      <Tile label={`${c.ticker || "Ticker"} 7d score`} value={fmtScore(c.tickerScore)} />
      <Tile label={`${c.sectorName || "Sector"} 7d`} value={fmtScore(c.sectorScore)} />
      <div className="border px-3 py-2" style={{ borderColor: "var(--hoip-border)", background: tone.bg }}>
        <div className="text-[9px] uppercase tracking-wide" style={{ color: "var(--hoip-text-tertiary)" }}>Vs sector</div>
        <div className="text-[13px] font-medium" style={{ color: tone.color }}>
          {c.status === "Hotter" ? "▲ Hotter than sector" : c.status === "Cooler" ? "▼ Cooler than sector" : "● In line with sector"}
        </div>
        <StatusBadge
          tier="info"
          text="7-day rolling"
          title="Headline sentiment score vs sector average. Not a trade recommendation."
        />
      </div>
    </div>
  );
}

function Tile({ label, value }) {
  return (
    <div className="border px-3 py-2" style={{ borderColor: "var(--hoip-border)", background: "var(--hoip-card)" }}>
      <div className="text-[9px] uppercase tracking-wide" style={{ color: "var(--hoip-text-tertiary)" }}>{label}</div>
      <div className="text-[18px] font-mono-data font-medium">{value}</div>
    </div>
  );
}

function fmtScore(n) {
  if (n == null || Number.isNaN(Number(n))) return "—";
  const v = Number(n);
  return `${v > 0 ? "+" : ""}${v.toFixed(2)}`;
}
